import { getRappiServicesBaseURL } from '../../repositories';

export const RAPPI_SERVICES_BASE_URL = getRappiServicesBaseURL();
